(function() {
  if (customElements.get('age-verification-popup')) {
    return;
  }

  class AgeVerificationPopup extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-overlay]');
      this.closeButton = this.querySelector('[data-close]');
      this.acceptButton = this.querySelector('[data-accept]');
      this.declineButton = this.querySelector('[data-decline]');

      this.storageKey = this.dataset.storageKey || 'age-verification';
      this.showOnce = this.dataset.showOnce !== 'false';
      this.redirectUrl = this.dataset.redirectUrl || '';
      this.designMode = this.dataset.designMode === 'true';

      this.handleOverlayClick = this.handleOverlayClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleAcceptClick = this.handleAcceptClick.bind(this);
      this.handleDeclineClick = this.handleDeclineClick.bind(this);
      this.handleKeyup = this.handleKeyup.bind(this);

      this.bindEvents();

      if (this.shouldOpen()) {
        this.open();
      }
    }

    disconnectedCallback() {
      this.unbindEvents();
      this.unlockScroll();
    }

    bindEvents() {
      if (this.overlay) {
        this.overlay.addEventListener('click', this.handleOverlayClick);
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.handleCloseClick);
      }
      if (this.acceptButton) {
        this.acceptButton.addEventListener('click', this.handleAcceptClick);
      }
      if (this.declineButton) {
        this.declineButton.addEventListener('click', this.handleDeclineClick);
      }
      document.addEventListener('keyup', this.handleKeyup);
    }

    unbindEvents() {
      if (this.overlay) {
        this.overlay.removeEventListener('click', this.handleOverlayClick);
      }
      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.handleCloseClick);
      }
      if (this.acceptButton) {
        this.acceptButton.removeEventListener('click', this.handleAcceptClick);
      }
      if (this.declineButton) {
        this.declineButton.removeEventListener('click', this.handleDeclineClick);
      }
      document.removeEventListener('keyup', this.handleKeyup);
    }

    shouldOpen() {
      if (this.designMode || !this.showOnce) {
        return true;
      }

      try {
        return localStorage.getItem(this.storageKey) !== 'accepted';
      } catch (e) {
        return true;
      }
    }

    open() {
      this.hidden = false;
      this.lockScroll();
    }

    close() {
      this.hidden = true;
      this.unlockScroll();
    }

    persistAcceptedState() {
      if (!this.showOnce || this.designMode) {
        return;
      }

      try {
        localStorage.setItem(this.storageKey, 'accepted');
      } catch (e) {}
    }

    redirect() {
      if (this.designMode || !this.redirectUrl) {
        this.close();
        return;
      }

      window.location.assign(this.redirectUrl);
    }

    lockScroll() {
      document.documentElement.classList.add('age-verification-open');
      document.body.classList.add('age-verification-open');
    }

    unlockScroll() {
      document.documentElement.classList.remove('age-verification-open');
      document.body.classList.remove('age-verification-open');
    }

    handleOverlayClick() {
      this.redirect();
    }

    handleCloseClick() {
      this.redirect();
    }

    handleAcceptClick() {
      this.persistAcceptedState();
      this.close();
    }

    handleDeclineClick() {
      this.redirect();
    }

    handleKeyup(event) {
      if (event.key === 'Escape' && !this.hidden) {
        this.redirect();
      }
    }
  }

  customElements.define('age-verification-popup', AgeVerificationPopup);
})();
